import { render } from "./TeaserRow.vue?vue&type=template&id=7c4d9ea0"
import script from "./TeaserRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TeaserRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paragraphs/TeaserRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c4d9ea0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c4d9ea0', __exports__)) {
    api.reload('7c4d9ea0', __exports__)
  }
  
  module.hot.accept("./TeaserRow.vue?vue&type=template&id=7c4d9ea0", () => {
    api.rerender('7c4d9ea0', render)
  })

}


export default __exports__